export const UPDATE_ESTADO_CONTABLE_REQUEST = "UPDATE_ESTADO_CONTABLE_REQUEST";
export const UPDATE_ESTADO_CONTABLE_SUCCESS = "UPDATE_ESTADO_CONTABLE_SUCCESS";
export const UPDATE_ESTADO_CONTABLE_FAILURE = "UPDATE_ESTADO_CONTABLE_FAILURE";
export const UPDATE_ESTADO_CONTABLE_RESET = "UPDATE_ESTADO_CONTABLE_RESET";
